(function () {
  var screen = document.getElementById("cube");
  if (!screen) return;

  // Only the catalog sidebar cube tracks the mouse (marked with
  // data-follow-mouse="true" in main-collection.liquid). Everywhere else
  // (the home page) the cube just spins on its own.
  var followMouse = screen.dataset.followMouse === "true";

  var readout = document.getElementById("cube-readout");
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var width = 82;
  var height = 32;
  var size = width * height;

  var buffer = new Array(size);
  var zBuffer = new Float32Array(size);

  var distanceFromCam = 100;
  var K1 = 40;
  var step = 0.7;

  var A = 0.4;
  var B = 0.4;
  var C = 0;
  var targetA = A;
  var targetB = B;
  var drift = 0;
  var idle = 0;

  if (followMouse) {
    window.addEventListener(
      "mousemove",
      function (event) {
        targetB = (event.clientX / window.innerWidth - 0.5) * Math.PI * 1.6;
        targetA = (event.clientY / window.innerHeight - 0.5) * Math.PI * 1.2;
        idle = 0;
      },
      { passive: true }
    );
  }

  function face(i, j, k, character, s) {
    var x =
      j * s.sinA * s.sinB * s.cosC -
      k * s.cosA * s.sinB * s.cosC +
      j * s.cosA * s.sinC +
      k * s.sinA * s.sinC +
      i * s.cosB * s.cosC;

    var y =
      j * s.cosA * s.cosC +
      k * s.sinA * s.cosC -
      j * s.sinA * s.sinB * s.sinC +
      k * s.cosA * s.sinB * s.sinC -
      i * s.cosB * s.sinC;

    var z = k * s.cosA * s.cosB - j * s.sinA * s.cosB + i * s.sinB + distanceFromCam;

    var ooz = 1 / z;
    var xp = (width / 2 + K1 * ooz * x * 1.55) | 0;
    var yp = (height / 2 + K1 * ooz * y) | 0;
    var index = xp + yp * width;

    if (index >= 0 && index < size && ooz > zBuffer[index]) {
      zBuffer[index] = ooz;
      buffer[index] = character;
    }
  }

  function frame() {
    buffer.fill(" ");
    zBuffer.fill(0);

    if (followMouse) {
      idle++;
      if (idle > 90 && !reduceMotion) {
        drift += 0.004;
      }
      A += (targetA - A) * 0.07;
      B += (targetB + drift - B) * 0.07;
      C += 0.0015;
    } else {
      // homepage: always spinning on its own, no mouse tracking
      A += 0.012;
      B += 0.015;
      C += 0.004;
    }

    var s = {
      sinA: Math.sin(A),
      cosA: Math.cos(A),
      sinB: Math.sin(B),
      cosB: Math.cos(B),
      sinC: Math.sin(C),
      cosC: Math.cos(C)
    };

    for (var cubeX = -20; cubeX < 20; cubeX += step) {
      for (var cubeY = -20; cubeY < 20; cubeY += step) {
        face(cubeX, cubeY, -20, "@", s);
        face(20, cubeY, cubeX, "$", s);
        face(-20, cubeY, -cubeX, "~", s);
        face(-cubeX, cubeY, 20, "#", s);
        face(cubeX, -20, -cubeY, ";", s);
        face(cubeX, 20, cubeY, "+", s);
      }
    }

    var output = "";
    for (var row = 0; row < height; row++) {
      output += buffer.slice(row * width, (row + 1) * width).join("") + "\n";
    }
    screen.textContent = output;

    if (readout) {
      readout.textContent = "A " + A.toFixed(2) + " \u00b7 B " + B.toFixed(2);
    }

    requestAnimationFrame(frame);
  }

  frame();
})();
